import { Modal } from 'bootstrap';
import { modalsStopVideo } from './main.js';

const modalList = [];
const modal = document.querySelectorAll('.modal-gallery .modal');

const video_modals = document.querySelectorAll('.video-modal');

for (var i = 0; i < modal.length; i++) {
    modalList.push(modal[i].getAttribute('id'));
}

modal.forEach((element) => {
    const prev = element.querySelector('.modal-prev');
    const next = element.querySelector('.modal-next');

    var index = modalList.indexOf(element.getAttribute('id'));

    if (index == 0) {
        prev.disabled = true;
    } else if (index == modalList.length - 1) {
        next.disabled = true;
    }

    prev.addEventListener('click', function (event) {
        Modal.getInstance(element).hide(); // hide current
        new Modal(document.getElementById(modalList[index - 1])).toggle(); // show prev
    })

    next.addEventListener('click', function (event) {
        Modal.getInstance(element).hide(); // hide current
        new Modal(document.getElementById(modalList[index + 1])).toggle(); // show next
    })
});

/* stop video on modal close */
modalsStopVideo(video_modals);